"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsetVastuuApiIdentifier = exports.setVastuuApiIdentifier = void 0;
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/reliablePartnerSettings");
const Actions = require("../../actions/bid/reliablePartnerSettings");
const errorHandling_1 = require("../../utils/errorHandling");
const ajax_1 = require("../../utils/ajax");
const setVastuuApiIdentifier = (action$, store, { ajax, getToken, baseUrl }) => {
    const getUrl = (action) => `${baseUrl}api/customer/${action.payload.customerUuid}/reliable-partner/settings`;
    const ajaxOptions = (action) => ({
        headers: (0, ajax_1.getHeaders)(getToken),
        method: 'POST',
        url: getUrl(action),
        body: { identifier: action.payload.identifier }
    });
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.SET_API_IDENTIFIER_REQUEST), (0, operators_1.mergeMap)((action) => ajax(ajaxOptions(action)).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.setApiIdentifierSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.setApiIdentifierFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
};
exports.setVastuuApiIdentifier = setVastuuApiIdentifier;
function unsetVastuuApiIdentifier(action$, store, { ajax, getToken, baseUrl }) {
    const getUrl = (action) => {
        return `${baseUrl}api/customer/${action.payload.customerUuid}/reliable-partner/settings`;
    };
    const ajaxOptions = (action) => {
        return {
            headers: (0, ajax_1.getHeaders)(getToken),
            method: 'DELETE',
            url: getUrl(action)
        };
    };
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.UNSET_API_IDENTIFIER_REQUEST), (0, operators_1.mergeMap)((action) => {
        return ajax(ajaxOptions(action)).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.unsetApiIdentifierSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.unsetApiIdentifierFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.unsetVastuuApiIdentifier = unsetVastuuApiIdentifier;
//# sourceMappingURL=reliablePartnerSettings.js.map